import React from 'react';

const CompanyOverview = () => {
  const stats = [
    { number: "15+", label: "Years Experience" },
    { number: "10,000+", label: "Parts Cataloged" },
    { number: "500+", label: "Active Users" },
    { number: "24/7", label: "Catalog Access" }
  ];

  const features = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Quality Assurance",
      description: "All parts undergo rigorous quality testing to ensure reliability and performance."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Easy Access",
      description: "24/7 online access to our comprehensive parts catalog for easy identification and reference."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z" />
        </svg>
      ),
      title: "Expert Information",
      description: "Detailed technical information and specifications for accurate parts identification."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
        </svg>
      ),
      title: "Comprehensive Database",
      description: "Extensive database with detailed specifications and compatibility information."
    }
  ];

  return (
    <section id="about" className="section-padding bg-[#F5F1EB]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-secondary mb-4">
            About Our Company
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your comprehensive reference catalog for heavy truck spare parts identification
          </p>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-secondary">
              Comprehensive Parts Catalog for Heavy Trucks
            </h3>
            
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                We provide a comprehensive online catalog of heavy truck spare parts, serving the automotive 
                and industrial sectors with detailed parts information. Our mission is to 
                provide accurate, detailed specifications that help you identify the right parts 
                for your heavy trucks.
              </p>
              
              <p>
                With over 15 years of experience in the industry, we have built a comprehensive 
                database of parts information. We understand the critical importance of accurate 
                parts identification, which is why we maintain detailed specifications and 
                compatibility information for thousands of parts.
              </p>
              
              <p>
                Our commitment to accuracy extends beyond just cataloging parts. We provide 
                comprehensive technical information, detailed specifications, and expert 
                guidance to ensure you can identify the correct parts for your needs.
              </p>
            </div>

            {/* CTA Button */}
            <div className="pt-4">
              <button 
                onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                className="btn-primary"
              >
                Get in Touch
              </button>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/alvian-pratama-r-m16goj_lg-unsplash.jpg"
                alt="Heavy truck parts warehouse"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-primary bg-opacity-20"></div>
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-primary mb-2">15+</div>
                <div className="text-sm text-gray-600">Years of Excellence</div>
              </div>
            </div>
          </div>
        </div>

        

        {/* Mission Statement */}
        <div className="mt-16 bg-gray-50 rounded-2xl p-8 md:p-12 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-secondary mb-6">
            Our Mission
          </h3>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            To be the most comprehensive and accurate catalog of heavy truck spare parts, 
            providing detailed specifications and reliable information to help the transportation 
            industry identify the right parts. We are committed to accuracy, completeness, and 
            building a trusted resource for parts identification.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CompanyOverview;
